import React from 'react'
import { Button, Col, Container, Row } from 'components'
import {
    InteractionMobileMoneyPaymentIcon,
    OrangeMoneyIcon,
    WaveMoneyIcon
} from 'assets'
import { colors } from 'styles/colors'
import { constants } from 'helpers'
import { TFunction } from 'react-i18next'
import { useMobilePayment } from 'hooks'

type MobileMoneySelectionType = {
    mobileMoneyHandler: (mobileMoney: string) => void
    continueButtonText?: string
    t: TFunction<'translation', string>
}

export const MobileMoneySelection = ({
    mobileMoneyHandler,
    continueButtonText,
    t
}: MobileMoneySelectionType) => {
    const { mobilePaymentProviders } = useMobilePayment()
    const [selectedMobileMoney, setSelectedMobileMoney] = React.useState('')

    return (
        <Container sm={12} className="mobile-money--container">
            <Row>
                <Col md={12} className="mobile-money--title-container">
                    <InteractionMobileMoneyPaymentIcon color={colors.black} />
                    <p className="mobile-money--title">
                        {t('enrollment.mobileMoney')}
                    </p>
                </Col>
            </Row>
            <Row>
                <Col
                    md={12}
                    className="mobile-money--selection-title-container"
                >
                    <p>{t('chooseMobileMoneyProviders')}</p>
                </Col>
                <Col md={12} className="mobile-money--selection-container">
                    {mobilePaymentProviders?.includes(
                        constants.MOBILE_MONEY.WAVE
                    ) && (
                        <div className="mobile-money--icon-container">
                            <div
                                className={`mobile-money--icon ${
                                    selectedMobileMoney ===
                                    constants.MOBILE_MONEY.WAVE
                                        ? 'mobile-money--selected'
                                        : ''
                                }`.trim()}
                                onClick={() => {
                                    setSelectedMobileMoney(
                                        constants.MOBILE_MONEY.WAVE
                                    )
                                }}
                                aria-label="wave-money-icon-parent"
                            >
                                <WaveMoneyIcon size={100} />
                            </div>
                            <p className="mobile-money--icon-name">Wave</p>
                        </div>
                    )}
                    {mobilePaymentProviders?.includes(
                        constants.MOBILE_MONEY.ORANGE_MONEY
                    ) && (
                        <div>
                            <div
                                className={`mobile-money--icon ${
                                    selectedMobileMoney ===
                                    constants.MOBILE_MONEY.ORANGE_USSD
                                        ? 'mobile-money--selected'
                                        : ''
                                }`.trim()}
                                onClick={() => {
                                    setSelectedMobileMoney(
                                        constants.MOBILE_MONEY.ORANGE_USSD
                                    )
                                }}
                                aria-label="orange-money-icon"
                            >
                                <OrangeMoneyIcon />
                            </div>
                            <p className="mobile-money--icon-name">OM</p>
                        </div>
                    )}
                </Col>
            </Row>
            <Row>
                <Col md={12} className="mobile-money--button-container">
                    {selectedMobileMoney && (
                        <div className="client-details--bottom-button-parent">
                            <Button
                                className="client-details--bottom-button"
                                style="primary"
                                onClick={() =>
                                    mobileMoneyHandler(selectedMobileMoney)
                                }
                            >
                                {continueButtonText || t('continue')}
                            </Button>
                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
